import React from "react";

export declare interface Props {
  children: React.ReactNode;
}

export function CenteredContainer({ children }: Props) {
  return (
    <section style={{ height: "calc(100vh - var(--eg-header-height))" }}>
      <div className="container py-5 h-100">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-12 col-md-8 col-lg-6 col-xl-5">
            <div className="card shadow-2-strong">
              <div className="card-body p-5">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
